module.exports = "/_next/static/images/Hero@3x-d8a400a47b6eb6cedca3051970a604f8.webp";